/* Cart drawer rewards use the same live bundle page milestones as the builder. */
(() => {
 const root=document.querySelector('[data-cart-rewards]'); if(!root)return;
 const tierBox=root.querySelector('[data-cart-rewards-tiers]');
 const countBox=root.querySelector('[data-cart-rewards-count]');
 const nextBox=root.querySelector('[data-cart-rewards-next]');
 const track=root.querySelector('[data-cart-rewards-track]');
 const fill=root.querySelector('[data-cart-rewards-fill]');
 const fraction=root.querySelector('[data-cart-rewards-fraction]');
 const shopRoot=window.MudjugConfig?.root||'/';
 const link=document.querySelector('[data-global-kit]')?.dataset.builderUrl || (document.querySelector('[data-bundle-builder]') ? window.location.pathname : '/pages/build-a-bundle');
 let config=null,cart=null;
  const nextRewardMessage = (tiers, count) => {
    const rewards = tiers.filter(t => /free.*lid|free.*stealth|free shipping/i.test(`${t.label} ${t.description}`));
    const next = rewards.find(t => count < t.threshold);
    if (!next) return 'All field kit milestones unlocked!';
    const combined = `${next.label} ${next.description}`;
    const name = /free.*lid/i.test(combined) ? 'your FREE Dip Can Lid' : /free.*stealth/i.test(combined) ? 'your FREE Basic Stealth' : 'FREE standard shipping';
    const remaining = next.threshold-count;
    return `Add ${remaining} more Mudjug${remaining===1?'':'s'} to unlock ${name}`;
  };
const getCollectionEligible = async (builder) => {
    const handle = builder?.dataset.eligibleCollection;
    if (!handle || handle === 'all') return new Set();
    const ids = new Set([...builder.querySelectorAll('[data-bundle-product]')].map(node => String(node.dataset.productId)).filter(Boolean));
    for (let page = 1; page <= 100; page++) {
      const res = await fetch(`${shopRoot}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
      if (!res.ok) { if (ids.size) return ids; throw new Error('Unable to load eligible Mudjug collection'); }
      const products = (await res.json()).products || [];
      products.forEach(p => ids.add(String(p.id)));
      if (products.length < 250) return ids;
    }
    return ids;
  };
 const eligibleCount=()=>!cart?0:cart.items.filter(item=>{
  const props=item.properties||{};
  if(Object.keys(props).some(k=>k.toLowerCase().includes('mudjug_reward_candidate')))return false;
  return (config?.eligible?.has(String(item.product_id))??false);
 }).reduce((sum,item)=>sum+item.quantity,0);
 function render(){
  if(!cart)return;
  const count=eligibleCount();countBox.textContent=`${count} ${count===1?'MUDJUG':'MUDJUGS'}`;
  if(!config?.tiers?.length){nextBox.textContent='Explore your field kit rewards in the bundle builder.';return;}
  const tiers=config.tiers;
  const next=tiers.find(t=>count<t.threshold);
  const prev=[...tiers].reverse().find(t=>count>=t.threshold);
  const last=tiers[tiers.length-1];
  const target=next?.threshold||last.threshold;
  // Fill cumulatively across all milestones. Never reset to 0 at a completed tier.
  const percent=Math.max(0,Math.min(100,(count/Math.max(1,last.threshold))*100));
  if(fraction)fraction.textContent=`${count} / ${target}`;
  fill.style.width=`${percent}%`;track.setAttribute('aria-valuemax',String(last.threshold));track.setAttribute('aria-valuenow',String(Math.min(count,last.threshold)));
  tierBox.replaceChildren();
  tiers.forEach(t=>{
   const item=document.createElement('div');item.className='cart-rewards__tier'+(count>=t.threshold?' is-done':'')+(next===t?' is-next':'');
   const badge=document.createElement('span');badge.className='cart-rewards__badge';badge.textContent=count>=t.threshold?'✓':String(t.threshold);
   badge.title=`${t.threshold} ${t.threshold===1?'Mudjug':'Mudjugs'}: ${t.description||t.label}`;
   badge.setAttribute('aria-label',badge.title);
   item.append(badge);tierBox.append(item);
  });
  nextBox.textContent = nextRewardMessage(tiers, count);
 }
 async function loadConfig(){try{
  const r=await fetch(link,{credentials:'same-origin',headers:{Accept:'text/html'}});if(!r.ok)return;
  const doc=new DOMParser().parseFromString(await r.text(),'text/html');
  const builder=doc.querySelector('[data-bundle-builder]');if(!builder)return;
  const tiers=[...builder.querySelectorAll('[data-bundle-milestone]')].map(n=>({threshold:Number(n.dataset.threshold),label:n.querySelector('.bundle-milestone__copy strong')?.textContent?.trim()||'',description:n.querySelector('.bundle-milestone__copy > span')?.textContent?.trim()||''})).filter(t=>t.threshold>0).sort((a,b)=>a.threshold-b.threshold);
  const eligible=await getCollectionEligible(builder);
  config={tiers,eligible};render();
 }catch(_){}}
 async function loadCart(){try{const r=await fetch(`${shopRoot}cart.js`,{credentials:'same-origin'});if(r.ok){cart=await r.json();render();}}catch(_){}}
 document.addEventListener('mudjug:cart-updated',e=>{cart=e.detail;render()});
 document.addEventListener('shopify:section:load',()=>{loadConfig();loadCart()});
  document.addEventListener('cart:updated', loadCart);
  document.addEventListener('cart:refresh', loadCart);
 window.addEventListener('pageshow',loadCart);
 loadConfig();loadCart();
})();
